var K = Object.defineProperty, j = Object.defineProperties;
var X = Object.getOwnPropertyDescriptors;
var L = Object.getOwnPropertySymbols;
var W = Object.prototype.hasOwnProperty, J = Object.prototype.propertyIsEnumerable;
var A = (e, t, s) => t in e ? K(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, C = (e, t) => {
  for (var s in t || (t = {}))
    W.call(t, s) && A(e, s, t[s]);
  if (L)
    for (var s of L(t))
      J.call(t, s) && A(e, s, t[s]);
  return e;
}, _ = (e, t) => j(e, X(t));
import { $emit as h } from "../utils/gogocodeTransfer.js";
import { ElInput as Q } from "element-plus";
import { defineComponent as G, createVNode as d, mergeProps as w, resolveComponent as b, openBlock as f, createElementBlock as V, normalizeClass as v, Fragment as Y, renderList as ee, createBlock as P, resolveDirective as te, withDirectives as H, createElementVNode as y, renderSlot as O, Transition as se, withCtx as D, toDisplayString as T, vShow as ne, createTextVNode as R } from "vue";
import { c as ae, d as x, f as S, v as ie, n as re, h as oe, j as ce } from "../util-b2b0dc25.js";
import { V as le } from "../virtual-list-42654601.js";
import B from "./components/cascader-panel/store.js";
import de from "../assets/utils/merge.js";
import he from "../assets/utils/aria-utils.js";
import { _ as E } from "../_plugin-vue_export-helper-dad06003.js";
import { S as ue } from "../scrollbar2-f7c66394.js";
import { isDef as pe } from "../assets/utils/shared.js";
import m from "../assets/utils/vue-popper.js";
import me from "../assets/utils/clickoutside.js";
import fe from "../assets/mixins/emitter.js";
import "../icon/index.js";
import { I as ge } from "../icon-51ff7679.js";
import "./components/cascader-panel/node.js";
import "../assets/utils/scrollbar-width.js";
import "../assets/utils/dom.js";
import "../scrollbar2/util.js";
import "../assets/utils/popup/popup-manager.js";
import "../assets/utils/popper.js";
const U = /* @__PURE__ */ G({
  inject: ["panel"],
  props: {
    node: {
      required: !0
    },
    nodeId: String
  },
  computed: {
    config() {
      return this.panel.config;
    },
    isLeaf() {
      return this.node.isLeaf;
    },
    isDisabled() {
      return this.node.isDisabled;
    },
    checkedValue() {
      return this.panel.checkedValue;
    },
    isChecked() {
      return this.node.isSameNode(this.checkedValue);
    },
    inActivePath() {
      return this.isInPath(this.panel.activePath);
    },
    inCheckedPath() {
      return this.config.checkStrictly ? this.panel.checkedNodePaths.some((e) => this.isInPath(e)) : !1;
    },
    value() {
      return this.node.getValueByOption();
    }
  },
  methods: {
    handleExpand() {
      const {
        panel: e,
        node: t,
        isDisabled: s,
        config: i
      } = this, {
        multiple: n,
        checkStrictly: a
      } = i;
      !a && s || t.loading || (i.lazy && !t.loaded ? e.lazyLoad(t, () => {
        const {
          isLeaf: o
        } = this;
        if (o || this.handleExpand(), n) {
          const r = o ? t.checked : !1;
          this.handleMultiCheckChange(r);
        }
      }) : e.handleExpand(t));
    },
    handleCheckChange() {
      const {
        panel: e,
        value: t,
        node: s
      } = this;
      e.handleCheckChange(t), e.handleExpand(s);
    },
    handleMultiCheckChange(e) {
      this.node.doCheck(e), this.panel.calculateMultiCheckedValue();
    },
    isInPath(e) {
      const {
        node: t
      } = this;
      return (e[t.level - 1] || {}).uid === t.uid;
    },
    renderPrefix(e) {
      return null;
    },
    renderPostfix(e) {
      const {
        node: t,
        isLeaf: s
      } = this;
      return t.loading ? this.renderLoadingIcon(e) : s ? null : this.renderExpandIcon(e);
    },
    renderLoadingIcon(e) {
      return d("i", {
        class: "el-icon-loading el-cascader-node__postfix"
      }, null);
    },
    renderExpandIcon(e) {
      return d("i", {
        class: "el-icon-arrow-right el-cascader-node__postfix"
      }, null);
    },
    renderContent(e) {
      const {
        panel: t,
        node: s
      } = this, i = t.renderLabelFn, n = i ? i({
        node: s,
        data: s.data
      }) : null;
      return d("span", {
        class: "el-cascader-node__label"
      }, [n || s.label]);
    }
  },
  render(e) {
    const {
      inActivePath: t,
      inCheckedPath: s,
      isChecked: i,
      isLeaf: n,
      isDisabled: a,
      config: o,
      nodeId: r
    } = this, {
      expandTrigger: l,
      checkStrictly: c,
      multiple: p
    } = o, $ = !c && a, k = {
      on: {}
    };
    return l === "click" ? k.on.click = this.handleExpand : (k.on.mouseenter = (I) => {
      this.handleExpand(), this.$emit("expand", I);
    }, k.on.focus = (I) => {
      this.handleExpand(), this.$emit("expand", I);
    }), n && !a && !c && !p && (k.on.click = this.handleCheckChange), d("li", w({
      role: "menuitem",
      id: r,
      "aria-expanded": t,
      tabindex: $ ? null : -1,
      class: {
        "el-cascader-node": !0,
        "is-selectable": c,
        "in-active-path": t,
        "in-checked-path": s,
        "is-active": i,
        "is-disabled": $
      }
    }, k), [this.renderPrefix(e), this.renderContent(e), this.renderPostfix(e)]);
  }
}), ye = /* @__PURE__ */ G({
  name: "rCascaderMenu",
  inject: ["panel"],
  props: {
    nodes: {
      type: Array,
      required: !0
    },
    index: Number,
    /**
     * 每项高度
     */
    itemHeight: {
      type: [Number, String],
      default: 40
    },
    /**
     * 可视区域高度，当虚拟列表组件或所在父组件初始高度不确定，比如：diaplay为none，导致无法准确获取容器高度，可以直接用此属性设置可视区域高度
     */
    wrapperHeight: {
      type: [Number, String],
      default: 188
    }
  },
  data() {
    return {
      activeNode: null,
      hoverTimer: null,
      id: ae()
    };
  },
  computed: {
    isEmpty() {
      return !this.nodes.length;
    },
    menuId() {
      return `cascader-menu-${this.id}-${this.index}`;
    }
  },
  methods: {
    handleExpand(e) {
      this.activeNode = e.target;
    },
    handleMouseMove(e) {
      const {
        activeNode: t,
        hoverTimer: s
      } = this, {
        hoverZone: i
      } = this.$refs;
      if (!(!t || !i))
        if (t.contains(e.target)) {
          clearTimeout(s);
          const {
            left: n
          } = this.$el.getBoundingClientRect(), a = e.clientX - n, {
            offsetWidth: o,
            offsetHeight: r
          } = this.$el, l = t.offsetTop, c = l + t.offsetHeight;
          i.innerHTML = `
          <path style="pointer-events: auto;" fill="transparent" d="M${a} ${l} L${o} 0 V${l} Z" />
          <path style="pointer-events: auto;" fill="transparent" d="M${a} ${c} L${o} ${r} V${c} Z" />
        `;
        } else
          s || (this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold));
    },
    clearHoverZone() {
      const {
        hoverZone: e
      } = this.$refs;
      e && (e.innerHTML = "");
    },
    renderEmptyText(e) {
      return d("div", {
        class: "el-cascader-menu__empty-text"
      }, [this.t("el.cascader.noData")]);
    },
    renderNodeList(e) {
      const {
        menuId: t
      } = this, {
        isHoverMenu: s
      } = this.panel, i = {
        on: {}
      };
      return s && (i.on.expand = this.handleExpand), [...this.nodes.map((a, o) => {
        const {
          hasChildren: r
        } = a;
        return d(U, w({
          key: a.uid,
          node: a,
          "node-id": `${t}-${o}`,
          "aria-haspopup": r,
          "aria-owns": r ? t : null
        }, i), null);
      }), s ? d("svg", {
        ref: "hoverZone",
        class: "el-cascader-menu__hover-zone"
      }, null) : null];
    },
    renderNodeItem(e, t) {
      const {
        hasChildren: s
      } = e, {
        menuId: i
      } = this, {
        isHoverMenu: n
      } = this.panel, a = {
        on: {}
      };
      return n && (a.on.expand = this.handleExpand), d(U, w({
        key: e.uid,
        node: e,
        "node-id": `${i}-${t}`,
        "aria-haspopup": s,
        "aria-owns": s ? i : null
      }, a), null);
    },
    virtualListScrollToIndex(e) {
      this.$refs.VirtualList.scrollToIndex(e);
    }
  },
  render(e) {
    const {
      isEmpty: t,
      menuId: s
    } = this;
    return this.panel.isHoverMenu && this.handleMouseMove, // <ScrollBar2
    //   tag="ul"
    //   role="menu"
    //   id={menuId}
    //   class="el-cascader-menu"
    //   wrap-class="el-cascader-menu__wrap"
    //   view-class={{
    //     'el-cascader-menu__list': true,
    //     'is-empty': isEmpty
    //   }}
    //   {...events}
    // >
    //   {isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)}
    // </ScrollBar2>
    // <Scrollbar2 :wrap-class="computedWrapperClass" ref="listRef" :native="true">
    //   <div
    //     class="r-virtual-list-wrapper"
    //     :style="{
    //       height: `${wrapperHeight}px`
    //     }"
    //   >
    //     <div
    //       class="r-virtual-list-options"
    //       :style="{
    //         transform: `translateY(${transformY}px)`
    //       }"
    //     >
    //       <div
    //         class="r-virtual-list-option"
    //         :ref="`optionRef${index}`"
    //         v-for="(item, index) in optionsData"
    //         :key="(keyStr && item[keyStr]) || index"
    //       >
    //         <slot name="option" :optionData="item"></slot>
    //       </div>
    //     </div>
    //   </div>
    // </Scrollbar2>
    d(le, {
      data: this.nodes,
      tag: "ul",
      role: "menu",
      id: s,
      class: "el-cascader-menu",
      "wrapper-class": "el-cascader-menu__wrap",
      "view-class": {
        "el-cascader-menu__list": !0,
        "is-empty": t
      },
      wrapperHeight: this.wrapperHeight,
      itemHeight: this.itemHeight,
      ref: "VirtualList"
    }, {
      default: () => [t ? d("div", {
        slot: "empty"
      }, [this.renderEmptyText(e)]) : null],
      option: ({
        optionData: i,
        optionIndex: n
      }) => this.renderNodeItem(i, n)
    });
  }
}), { keys: g } = he, ke = {
  expandTrigger: "click",
  // or hover
  multiple: !1,
  checkStrictly: !1,
  // whether all nodes can be selected
  emitPath: !0,
  // wether to emit an array of all levels value in which node is located
  lazy: !1,
  lazyLoad: re,
  value: "value",
  label: "label",
  children: "children",
  leaf: "leaf",
  disabled: "disabled",
  hoverThreshold: 500
}, Z = (e) => !e.getAttribute("aria-owns"), z = (e, t) => {
  const { parentNode: s } = e;
  if (s) {
    const i = s.querySelectorAll(
      '.el-cascader-node[tabindex="-1"]'
    ), n = Array.prototype.indexOf.call(i, e);
    return i[n + t] || null;
  }
  return null;
}, F = (e, t) => {
  if (!e)
    return;
  const s = e.id.split("-");
  return Number(s[s.length - 2]);
}, N = (e) => {
  e && (e.focus(), !Z(e) && e.click());
}, ve = (e) => {
  if (!e)
    return;
  const t = e.querySelector("input");
  t ? t.click() : Z(e) && e.click();
}, be = {
  name: "rCascaderPanel",
  components: {
    CascaderMenu: ye
  },
  props: {
    value: {},
    options: Array,
    props: Object,
    border: {
      type: Boolean,
      default: !0
    },
    renderLabel: Function,
    /**
     * 每项高度
     */
    itemHeight: {
      type: [Number, String],
      default: 40
    },
    /**
     * 可视区域高度，当虚拟列表组件或所在父组件初始高度不确定，比如：diaplay为none，导致无法准确获取容器高度，可以直接用此属性设置可视区域高度
     */
    wrapperHeight: {
      type: [Number, String],
      default: 188
    }
  },
  provide() {
    return {
      panel: this
    };
  },
  data() {
    return {
      checkedValue: null,
      checkedNodePaths: [],
      store: [],
      menus: [],
      activePath: [],
      loadCount: 0
    };
  },
  computed: {
    config() {
      return de(C({}, ke), this.props || {});
    },
    multiple() {
      return this.config.multiple;
    },
    checkStrictly() {
      return this.config.checkStrictly;
    },
    leafOnly() {
      return !this.checkStrictly;
    },
    isHoverMenu() {
      return this.config.expandTrigger === "hover";
    },
    renderLabelFn() {
      return this.renderLabel || this.$slots.default && this.$slots.default();
    }
  },
  watch: {
    value() {
      this.syncCheckedValue(), this.checkStrictly && this.calculateCheckedNodePaths();
    },
    options: {
      handler: function() {
        this.initStore();
      },
      immediate: !0,
      deep: !0
    },
    checkedValue(e) {
      x(e, this.value) || (this.checkStrictly && this.calculateCheckedNodePaths(), h(this, "update:value", e), h(this, "change", e));
    }
  },
  mounted() {
    this.isEmptyValue(this.value) || this.syncCheckedValue();
  },
  methods: {
    initStore() {
      const { config: e, options: t } = this;
      e.lazy && S(t) ? this.lazyLoad() : (this.store = new B(t, e), this.menus = [this.store.getNodes()], this.syncMenuState());
    },
    syncCheckedValue() {
      const { value: e, checkedValue: t } = this;
      x(e, t) || (this.activePath = [], this.checkedValue = e, this.syncMenuState());
    },
    syncMenuState() {
      const { multiple: e, checkStrictly: t } = this;
      this.syncActivePath(), e && this.syncMultiCheckState(), t && this.calculateCheckedNodePaths(), this.$nextTick(this.scrollIntoView);
    },
    syncMultiCheckState() {
      this.getFlattedNodes(this.leafOnly).forEach((t) => {
        t.syncCheckState(this.checkedValue);
      });
    },
    isEmptyValue(e) {
      const { multiple: t, config: s } = this, { emitPath: i } = s;
      return t || i ? S(e) : !1;
    },
    syncActivePath() {
      const { store: e, multiple: t, activePath: s, checkedValue: i } = this;
      if (S(s))
        if (this.isEmptyValue(i))
          this.activePath = [], this.menus = [e.getNodes()];
        else {
          const n = t ? i[0] : i, o = ((this.getNodeByValue(n) || {}).pathNodes || []).slice(0, -1);
          this.expandNodes(o);
        }
      else {
        const n = s.map(
          (a) => this.getNodeByValue(a.getValue())
        );
        this.expandNodes(n);
      }
    },
    expandNodes(e) {
      e.forEach((t) => this.handleExpand(
        t,
        !0
        /* silent */
      ));
    },
    calculateCheckedNodePaths() {
      const { checkedValue: e, multiple: t } = this, s = t ? oe(e) : [e];
      this.checkedNodePaths = s.map((i) => {
        const n = this.getNodeByValue(i);
        return n ? n.pathNodes : [];
      });
    },
    handleKeyDown(e) {
      const { target: t, keyCode: s } = e;
      switch (s) {
        case g.up:
          const i = z(t, -1);
          N(i);
          break;
        case g.down:
          const n = z(t, 1);
          N(n);
          break;
        case g.left:
          const a = this.$arrRefs.menu[F(t) - 1];
          if (a) {
            const r = a.$el.querySelector(
              '.el-cascader-node[aria-expanded="true"]'
            );
            N(r);
          }
          break;
        case g.right:
          const o = this.$arrRefs.menu[F(t) + 1];
          if (o) {
            const r = o.$el.querySelector(
              '.el-cascader-node[tabindex="-1"]'
            );
            N(r);
          }
          break;
        case g.enter:
          ve(t);
          break;
        case g.esc:
        case g.tab:
          h(this, "close");
          break;
      }
    },
    handleExpand(e, t) {
      if (!e)
        return;
      const { activePath: s } = this, { level: i } = e, n = s.slice(0, i - 1), a = this.menus.slice(0, i);
      if (e.isLeaf || (n.push(e), a.push(e.children)), this.activePath = n, this.menus = a, !t) {
        const o = n.map((l) => l.getValue()), r = s.map((l) => l.getValue());
        ie(o, r) || (h(this, "active-item-change", o), h(this, "expand-change", o));
      }
    },
    handleCheckChange(e) {
      this.checkedValue = e;
    },
    lazyLoad(e, t) {
      const { config: s } = this;
      e || (e = e || { root: !0, level: 0 }, this.store = new B([], s), this.menus = [this.store.getNodes()]), e.loading = !0;
      const i = (n) => {
        const a = e.root ? null : e;
        if (n && n.length && this.store.appendNodes(n, a), e.loading = !1, e.loaded = !0, Array.isArray(this.checkedValue)) {
          const o = this.checkedValue[this.loadCount++], r = this.config.value, l = this.config.leaf;
          if (Array.isArray(n) && n.filter((c) => c[r] === o).length > 0) {
            const c = this.store.getNodeByValue(o);
            c.data[l] || this.lazyLoad(c, () => {
              this.handleExpand(c);
            }), this.loadCount === this.checkedValue.length && this.$parent.computePresentText();
          }
        }
        t && t(n);
      };
      s.lazyLoad(e, i);
    },
    /**
     * public methods
     */
    calculateMultiCheckedValue() {
      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(
        (e) => e.getValueByOption()
      );
    },
    scrollIntoView() {
      if (this.$isServer || this.options.findIndex(
        (s) => s.value === this.value[0]
      ) < 0)
        return;
      (this.$arrRefs.menu || []).forEach((s, i) => {
        const n = this.options.findIndex(
          (a) => a.value === this.value[i]
        );
        n >= 0 && s.virtualListScrollToIndex(n);
      });
    },
    getNodeByValue(e) {
      return this.store.getNodeByValue(e);
    },
    getFlattedNodes(e) {
      const t = !this.config.lazy;
      return this.store.getFlattedNodes(e, t);
    },
    getCheckedNodes(e) {
      const { checkedValue: t, multiple: s } = this;
      return s ? this.getFlattedNodes(e).filter((n) => n.checked) : this.isEmptyValue(t) ? [] : [this.getNodeByValue(t)];
    },
    clearCheckedNodes() {
      const { config: e, leafOnly: t } = this, { multiple: s, emitPath: i } = e;
      s ? (this.getCheckedNodes(t).filter((n) => !n.isDisabled).forEach((n) => n.doCheck(!1)), this.calculateMultiCheckedValue()) : this.checkedValue = i ? [] : null;
    },
    getRefSetter(e) {
      return (t) => {
        !this.$arrRefs && (this.$arrRefs = {}), !this.$arrRefs[e] && (this.$arrRefs[e] = []), t && this.$arrRefs[e].push(t);
      };
    }
  },
  beforeUpdate() {
    this.$arrRefs && (this.$arrRefs = {});
  },
  emits: [
    "update:value",
    "change",
    "active-item-change",
    "expand-change",
    "close"
  ]
};
function Ve(e, t, s, i, n, a) {
  const o = b("CascaderMenu");
  return f(), V(
    "div",
    {
      class: v(["el-cascader-panel", s.border && "is-bordered"]),
      onKeydown: t[0] || (t[0] = (...r) => a.handleKeyDown && a.handleKeyDown(...r))
    },
    [
      (f(!0), V(
        Y,
        null,
        ee(n.menus, (r, l) => (f(), P(o, {
          ref_for: !0,
          ref: a.getRefSetter("menu"),
          index: l,
          key: l,
          nodes: r,
          itemHeight: s.itemHeight,
          wrapperHeight: s.wrapperHeight
        }, null, 8, ["index", "nodes", "itemHeight", "wrapperHeight"]))),
        128
        /* KEYED_FRAGMENT */
      ))
    ],
    34
    /* CLASS, HYDRATE_EVENTS */
  );
}
const Ce = /* @__PURE__ */ E(be, [["render", Ve], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/symbol-cascader/components/cascader-panel/cascader-panel.vue"]]), Ne = {
  props: {
    placement: {
      type: String,
      default: "bottom-start"
    },
    // appendToBody: Popper.props.appendToBody,
    visibleArrow: {
      type: Boolean,
      default: !0
    },
    arrowOffset: m.props.arrowOffset,
    offset: m.props.offset,
    boundariesPadding: m.props.boundariesPadding,
    popperOptions: m.props.popperOptions,
    transformOrigin: m.props.transformOrigin,
    /**
     * 每项高度
     */
    itemHeight: {
      type: [Number, String],
      default: 40
    },
    /**
     * 可视区域高度，当虚拟列表组件或所在父组件初始高度不确定，比如：diaplay为none，导致无法准确获取容器高度，可以直接用此属性设置可视区域高度
     */
    wrapperHeight: {
      type: [Number, String],
      default: 188
    }
  },
  methods: m.methods,
  data: m.data,
  beforeDestroy: m.beforeDestroy
}, xe = {
  name: "rCascader",
  model: {
    prop: "value",
    event: "change"
  },
  directives: { Clickoutside: me },
  mixins: [Ne, fe],
  inject: {
    elForm: {
      default: ""
    },
    elFormItem: {
      default: ""
    }
  },
  components: {
    Icon: ge,
    CascaderPanel: Ce,
    ScrollBar2: ue,
    Input: Q
  },
  props: {
    /**
     * 默认选中项 例如：[17, 6]
     */
    value: Array,
    /**
     * 数据树结构列表
     */
    options: Array,
    /**
     * 自定义下拉弹窗样式类名
     */
    popperClass: {
      type: String,
      default: "r-popper"
    },
    /**
     * 是否已禁用
     */
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    caretClass() {
      return {
        "icon-caret": !0
      };
    },
    panel() {
      return this.$refs.panel;
    },
    computedOptions() {
      return this.options.filter((e) => e.label.toUpperCase().includes(this.searchText.toUpperCase(this.searchText)));
    }
  },
  data() {
    return {
      dropDownVisible: !1,
      checkedValue: this.value,
      searchText: ""
    };
  },
  watch: {
    value(e) {
      x(e, this.checkedValue) || (this.checkedValue = e, this.computePresentContent());
    },
    checkedValue(e) {
      const { value: t, dropDownVisible: s } = this;
      (!x(e, t) || ce(t)) && (this.computePresentContent(), s && this.toggleDropDownVisible(!1), h(this, "update:value", e), h(this, "change", e), this.dispatch("ElFormItem", "el.form.change", [e]));
    },
    options: {
      handler() {
        this.$nextTick(this.computePresentContent);
      },
      deep: !0
    }
  },
  methods: {
    toggleDropDownVisible(e) {
      if (this.isDisabled)
        return;
      const { dropDownVisible: t } = this;
      e = pe(e) ? e : !t, e !== t && (this.dropDownVisible = e, e && this.$nextTick(() => {
        var s, i;
        (i = (s = this.$refs.searchInput) == null ? void 0 : s.focus) == null || i.call(s), this.updatePopper(), this.panel.scrollIntoView();
      }), h(this, "visible-change", e));
    },
    handleDropdownLeave() {
      this.doDestroy();
    },
    handleExpandChange(e) {
      this.$nextTick(this.updatePopper.bind(this)), h(this, "expand-change", e);
    },
    computePresentContent() {
    }
  },
  emits: ["update:value", "change", "visible-change", "expand-change"]
}, Ie = { class: "node node1" }, _e = { class: "input-area-span" }, Se = { class: "node node2" }, Me = { class: "input-area-span" }, we = {
  key: 1,
  class: "r-popper__empty-text"
};
function Pe(e, t, s, i, n, a) {
  const o = b("Input"), r = b("Icon"), l = b("CascaderPanel"), c = te("clickoutside");
  return H((f(), V("div", {
    ref: "reference",
    class: "r-cascader",
    onClick: t[3] || (t[3] = (p) => a.toggleDropDownVisible(!0))
  }, [
    y(
      "div",
      {
        class: v(["input-area", { isActive: n.dropDownVisible }])
      },
      [
        y("div", Ie, [
          y("span", _e, [
            n.dropDownVisible ? (f(), P(o, {
              key: 0,
              class: "r-cascader-search",
              modelValue: n.searchText,
              "onUpdate:modelValue": t[0] || (t[0] = (p) => n.searchText = p),
              ref: "searchInput"
            }, null, 8, ["modelValue"])) : O(e.$slots, "lv1", {
              key: 1,
              checkedValue: n.checkedValue
            })
          ]),
          d(r, {
            class: v(a.caretClass),
            name: "icon-caret_down"
          }, null, 8, ["class"])
        ]),
        y("div", Se, [
          y("span", Me, [
            O(e.$slots, "lv2", { checkedValue: n.checkedValue })
          ]),
          d(r, {
            class: v(a.caretClass),
            name: "icon-caret_down"
          }, null, 8, ["class"])
        ])
      ],
      2
      /* CLASS */
    ),
    d(se, {
      name: "el-zoom-in-top",
      onAfterLeave: a.handleDropdownLeave,
      persisted: ""
    }, {
      default: D(() => [
        H(y(
          "div",
          {
            ref: "popper",
            class: v(["el-popper", "el-cascader__dropdown", s.popperClass])
          },
          [
            a.computedOptions.length ? (f(), P(l, {
              key: 0,
              ref: "panel",
              value: n.checkedValue,
              "onUpdate:value": t[1] || (t[1] = (p) => n.checkedValue = p),
              options: a.computedOptions,
              border: !1,
              onExpandChange: a.handleExpandChange,
              onClose: t[2] || (t[2] = (p) => a.toggleDropDownVisible(!1)),
              itemHeight: e.itemHeight,
              wrapperHeight: e.wrapperHeight
            }, null, 8, ["value", "options", "onExpandChange", "itemHeight", "wrapperHeight"])) : (f(), V(
              "div",
              we,
              T(e.$t("bmui-symbol-cascader.noData")),
              1
              /* TEXT */
            ))
          ],
          2
          /* CLASS */
        ), [
          [ne, n.dropDownVisible]
        ])
      ]),
      _: 1
      /* STABLE */
    }, 8, ["onAfterLeave"])
  ])), [
    [c, () => a.toggleDropDownVisible(!1)]
  ]);
}
const De = /* @__PURE__ */ E(xe, [["render", Pe], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/symbol-cascader/components/cascader.vue"]]), q = {
  SPOT: "spot",
  MARGIN: "margin",
  FUTURES: "futures"
}, u = -9999, Te = {
  name: "rSymbolCascader",
  components: {
    RCascader: De
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /**
     * 交易对id
     */
    value: {
      type: [Number, String],
      default: null
    },
    /**
     * spot: 现货
     * margin: 杠杆
     */
    tradeMode: {
      type: String,
      default: "spot"
    },
    /**
     * 接口返回数据(具体结构见`symbol-selector`中的responseData说明)
     */
    responseData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tree: [],
      coinIdGroupSymbolMap: {},
      coinIdNameMap: {},
      arrayValue: [],
      optionItemAll: {
        label: this.$t("bmui-symbol-cascader.all"),
        value: u,
        children: [
          {
            label: this.$t("bmui-symbol-cascader.all"),
            value: u
          }
        ]
      }
    };
  },
  watch: {
    responseData: {
      deep: !0,
      handler() {
        this.handleParamsChange(this.tradeMode);
      },
      immediate: !0
    },
    tradeMode: {
      deep: !0,
      handler(e) {
        this.handleParamsChange(e);
      },
      immediate: !0
    },
    value: {
      deep: !0,
      handler() {
        this.handleParamsChange(this.tradeMode);
      },
      immediate: !0
    }
  },
  methods: {
    handleParamsChange(e) {
      switch (e) {
        case q.SPOT:
          this.setSpotList();
          break;
        case q.MARGIN:
          this.setMarginList();
          break;
      }
    },
    setSpotList() {
      const e = [], t = {}, s = {}, i = {}, n = {};
      for (const a of this.responseData)
        s[a.coinShortName] = a;
      for (const a of this.responseData)
        if (a.tradingPair && a.tradingPair.length && a.coinType !== 17) {
          const o = [];
          for (const r of a.tradingPair)
            if (!t[r.symbol]) {
              const [, l] = r.tag.split("/"), c = s[l];
              if (!c)
                continue;
              o.push({
                label: c.coinShortName,
                value: c.coinType,
                symbolId: r.symbol
              }), t[r.symbol] = a, i[`${a.coinType}+${c.coinType}`] = r.symbol, n[c.coinType] = c.coinShortName, this.value === r.symbol && (this.arrayValue = [a.coinType, c.coinType]);
            }
          n[a.coinType] = a.coinShortName, e.push({
            label: a.coinShortName,
            value: a.coinType,
            children: o
          });
        }
      this.tree = [this.optionItemAll, ...e], this.coinIdGroupSymbolMap = i, this.coinIdNameMap = _(C({}, n), {
        [u]: this.$t("bmui-symbol-cascader.all")
      }), this.value || (this.arrayValue = [u, u]);
    },
    setMarginList() {
      const e = [], t = {}, s = {};
      for (const i of this.responseData) {
        const {
          tradeMappingId: n,
          coinId: a,
          coinName: o,
          marketCoinId: r,
          marketCoinName: l
        } = i, c = e.find((p) => p.value === a);
        c ? (c.children = c.children || [], c.children.push({
          label: l,
          value: r,
          symbolId: n
        })) : e.push({
          label: o,
          value: a,
          children: [
            {
              label: l,
              value: r,
              symbolId: n
            }
          ]
        }), t[`${a}+${r}`] = n, s[a] = o, s[r] = l, this.value === n && (this.arrayValue = [a, r]);
      }
      this.tree = [this.optionItemAll, ...e], this.coinIdGroupSymbolMap = t, this.coinIdNameMap = _(C({}, s), {
        [u]: this.$t("bmui-symbol-cascader.all")
      }), this.value || (this.arrayValue = [u, u]);
    },
    onChecked(e) {
      Array.isArray(e) && e.length >= 2 && e[0] !== u && e[1] !== u ? h(
        this,
        "change",
        this.coinIdGroupSymbolMap[`${e[0]}+${e[1]}`]
      ) : h(this, "change", "");
    }
  },
  emits: ["change", "update:value"]
};
function Ee(e, t, s, i, n, a) {
  const o = b("RCascader");
  return f(), V("div", null, [
    d(o, {
      class: "r-symbol-cascader",
      value: n.arrayValue,
      options: n.tree,
      onChange: a.onChecked
    }, {
      lv1: D((r) => [
        R(
          T(r.checkedValue && r.checkedValue.length >= 2 ? n.coinIdNameMap[r.checkedValue[0]] : ""),
          1
          /* TEXT */
        )
      ]),
      lv2: D((r) => [
        R(
          T(r.checkedValue && r.checkedValue.length >= 2 ? n.coinIdNameMap[r.checkedValue[1]] : ""),
          1
          /* TEXT */
        )
      ]),
      _: 1
      /* STABLE */
    }, 8, ["value", "options", "onChange"])
  ]);
}
const M = /* @__PURE__ */ E(Te, [["render", Ee], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/symbol-cascader/symbol-cascader.vue"]]);
M.install = function(e) {
  e.component(M.name, M);
};
export {
  M as default
};
